/* global gtag */
import React, { useCallback, useEffect } from 'react';

import { useDispatch, useMappedState } from 'redux-react-hook';
import {
  updateDevLogin, goToNHSStubLogin, submitDevLogin,
} from 'redux/actions/login';
import LoginProvider from 'styles/blocks/login';
import { STRINGS } from 'config';
import { NHSLogoAndTextSVG } from 'assets/nhs/nhsLoginButton';
import media from 'styles/media';
import { getNextQuestionAfterNoConsent } from 'redux/actions/consultation';
import { NextButton } from '../nextButton';

export function NoConsentGiven() {
  const isMobile = media.mobile;
  const mapState = useCallback(state => ({
    devNHSLogin: state.loginReducer.devNHSLogin,
    federatedLoginProvider: state.consultationReducer.federatedLoginProvider,
    loginDetails: state.consultationReducer.loginDetails,
    treatmentCategory: state.consultationReducer.treatmentCategory,
    responseType: state.consultationReducer.responseType,
    product: state.consultationReducer.product,
  }), []);
  const {
    devNHSLogin, federatedLoginProvider, treatmentCategory, responseType,
  } = useMappedState(mapState);

  const sendGAVirtualPageView = useCallback(loginOption => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'virtual_page_view', {
        event_category: `/virtual/consultation/qpp/${treatmentCategory || ''}/${loginOption}`,
        event_label: responseType,
        value: 1,
      });
    }
  }, [treatmentCategory, responseType]);

  // Send /noConsentGiven virtual pageview on render of this question.
  useEffect(() => {
    sendGAVirtualPageView('noConsentGiven');
  }, [sendGAVirtualPageView]);

  // Create actions
  const dispatch = useDispatch();

  const FEDERATED_LOGIN_PROVIDER = STRINGS.FEDERATED_LOGIN_PROVIDER[federatedLoginProvider] || {};
  const { DEV_LOGIN_ENABLED } = STRINGS;

  const handleContinueAsGuest = () => {
    sendGAVirtualPageView(`${federatedLoginProvider}/continueAsGuest`);
    dispatch(getNextQuestionAfterNoConsent()).then(() => window.location.assign(window.location));
  };

  return (
    <LoginProvider.NoConsentPaddedDiv>
      <LoginProvider.Text>You chose not to consent to share your data with us.</LoginProvider.Text>
      <LoginProvider.Text>To use NHS login you need to consent to share your data.</LoginProvider.Text>
      <LoginProvider.Text>You can continue submitting your request without logging in.</LoginProvider.Text>

      <NextButton onClick={handleContinueAsGuest}>Continue without logging in</NextButton>
      {FEDERATED_LOGIN_PROVIDER === STRINGS.FEDERATED_LOGIN_PROVIDER.NHS_LOGIN_STUB ? (
        <LoginProvider.NHSLoginButton onClick={() => dispatch(goToNHSStubLogin())}><NHSLogoAndTextSVG isMobile={isMobile} /></LoginProvider.NHSLoginButton>
      ) : (
        <LoginProvider.LinkToNHSLogin href={FEDERATED_LOGIN_PROVIDER.REDIRECT_URL} onClick={() => sendGAVirtualPageView(federatedLoginProvider)}>
          <NHSLogoAndTextSVG isMobile={isMobile} />
        </LoginProvider.LinkToNHSLogin>
      )}
      {DEV_LOGIN_ENABLED ? (
        <LoginProvider>
          <LoginProvider.Textarea aria-label="dev log in details" value={devNHSLogin} onChange={event => dispatch(updateDevLogin(event.target.value))} />
          <NextButton onClick={() => dispatch(submitDevLogin(devNHSLogin))}>Dev login</NextButton>
        </LoginProvider>
      ) : null}
    </LoginProvider.NoConsentPaddedDiv>
  );
}
